<template>
    <div class="panel-pricing-wrapper">
        <!-- Primary Button Style -->
        <a v-if="!secondary" @click.prevent="openModal" href="#" class="btn btn-primary btn-block w-100">Start Conversation</a>
        
        <!-- Secondary Button Style -->
        <div v-if="secondary" role="group" class="btn-group btn-group-lg">
            <button @click.prevent="openModal" type="button" class="rounded-pill rounded-end-0 ps-4 pe-3 btn btn-primary">
                Click here to start a conversation
            </button>
            <button @click.prevent="openModal" type="button" class="border-end-0 border-top-0 border-bottom-0 border-light rounded-pill rounded-start-0 px-3 btn btn-primary">
                <i class="fi-messenger me-1"></i>
            </button>
        </div>

        <!-- Modal -->
        <vue-final-modal v-model="showModal">
            <div class="modal-dialog" role="document" v-if="panelConfiguration">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0">
                        <h5 class="modal-title">
                            Start Conversation With {{ panelConfiguration.display_name }}
                        </h5>
                        <button type="button" class="btn-close" aria-label="Close" @click="showModal = false"></button>
                    </div>
                    <div class="modal-body" v-if="localContext" style="text-align: left;">

                        <!-- <div>
                            <p>
                                {{ referralPageId }} - {{ advisorCompanyId }}
                            </p>
                        </div> -->

                        <!-- Select speciality -->
                        <div v-if="stage == 0">

                            <p>
                                What does your enquiry relate to?
                            </p>

                            <div class="speciality">
                                <a v-for="(speciality, i) in specialities" :key="i"
                                    @click.prevent="selectSpeciality(speciality)" href="#"
                                    class="btn btn-outline-primary me-2 mb-1">
                                    {{ speciality.name }}
                                </a>
                            </div>

                        </div>
                        <!-- / Select speciality -->

                        <!-- Has selected speciality -->
                        <div v-if="stage == 1" class="recommend-form">
                            <!-- Speciality -->
                            <div class="mb-3">
                                <label class="form-label" for="speciality">Speciality:</label> {{ form.speciality.name }}
                            </div>
                            <!-- / Speciality -->


                            <!-- Job Description -->
                            <div class="mb-4">
                                <label class="form-label" for="jobDescription">What would you like to discuss?</label>
                                <textarea :disabled="isSaving"
                                    placeholder="Just a bit of detail to help your professionals with the context, including whether you prefer fixed or variable fees"
                                    v-model="form.description" rows="4" class="form-control" id="jobDescription" />
                            </div>
                            <!-- / Job Description -->


                        </div>
                        <!-- / Has selected speciality -->

                        <!-- Setup account -->
                        <div v-if="stage == 2">

                            <!-- Tabs -->
                            <ul class="nav nav-tabs mb-4" id="accountTabs" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" :class="{ active: activeTab === 'new-account' }" 
                                            id="new-account-tab" type="button" role="tab" 
                                            @click="switchTab('new-account')"
                                            aria-controls="new-account" :aria-selected="activeTab === 'new-account'">New Account</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" :class="{ active: activeTab === 'login' }" 
                                            id="login-tab" type="button" role="tab" 
                                            @click="switchTab('login')"
                                            aria-controls="login" :aria-selected="activeTab === 'login'">Login</button>
                                </li>
                            </ul>

                            <!-- Tab Content -->
                            <div class="tab-content" id="accountTabsContent">
                                <!-- New Account Tab -->
                                <div class="tab-pane" :class="{ 'fade show active': activeTab === 'new-account' }" 
                                     id="new-account" role="tabpanel" 
                                     aria-labelledby="new-account-tab" v-show="activeTab === 'new-account'">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="mb-4">
                                                <label class="form-label" for="name">Your Name <span
                                                        class="text-danger">*</span></label>
                                                <input v-model="createAccountForm.name" class="form-control form-control-lg"
                                                    type="text" id="name" :disabled="isSaving" placeholder="Enter your name"
                                                    required>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="mb-4">
                                                <label class="form-label" for="email">Your Email <span
                                                        class="text-danger">*</span></label>
                                                <input v-model="createAccountForm.email" class="form-control form-control-lg"
                                                    type="text" id="email" :disabled="isSaving" placeholder="Enter your email"
                                                    required>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="mb-4">
                                                <label class="form-label" for="phone">Phone Number<span
                                                        class="text-danger">*</span></label>
                                                <input v-model="createAccountForm.phone" class="form-control form-control-lg"
                                                    type="tel" id="phone" :disabled="isSaving"
                                                    placeholder="Enter your mobile number" required>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="mb-4">
                                                <label class="form-label" for="password">Password <span
                                                        class="text-danger">*</span></label>
                                                <input v-model="createAccountForm.password" class="form-control form-control-lg"
                                                    type="password" id="password" :disabled="isSaving"
                                                    placeholder="Enter a password" required>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="mb-4">
                                                <label class="form-label" for="companyName">Company Name (If Applicable)</label>
                                                <input v-model="createAccountForm.company_name" class="form-control form-control-lg"
                                                    type="text" id="companyName" :disabled="isSaving"
                                                    placeholder="Enter your company name">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label>
                                                By signing up, you agree to Syndesi's <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/682df97de4a6e87953bf3559__Syndesi%20Platform%20Terms%20-%2021_5_25.pdf" target="_blank">Terms of Service</a> and <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/68760cbc4c58f63d40c37040_Syndesi%20Privacy%20Notice%20(15_07_25).docx.pdf" target="_blank">Privacy Policy</a>
                                        </label>
                                    </div>

                                    <div class="mb-4">
                                        <div class="form-check">
                                            <input v-model="createAccountForm.marketing_consent" class="form-check-input" type="checkbox" id="marketingConsent" :disabled="isSaving">
                                            <label class="form-check-label" for="marketingConsent">
                                                I agree to receive updates and marketing communications from Syndesi 
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <!-- Login Tab -->
                                <div class="tab-pane" :class="{ 'fade show active': activeTab === 'login' }" 
                                     id="login" role="tabpanel" 
                                     aria-labelledby="login-tab" v-show="activeTab === 'login'">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="mb-4">
                                                <label class="form-label" for="loginEmail">Email <span
                                                        class="text-danger">*</span></label>
                                                <input v-model="loginForm.email" class="form-control form-control-lg"
                                                    type="email" id="loginEmail" :disabled="isSaving" 
                                                    placeholder="Enter your email" required>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="mb-4">
                                                <label class="form-label" for="loginPassword">Password <span
                                                        class="text-danger">*</span></label>
                                                <input v-model="loginForm.password" class="form-control form-control-lg"
                                                    type="password" id="loginPassword" :disabled="isSaving"
                                                    placeholder="Enter your password" required>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="text-end">
                                                <a href="/forgot-password" target="_blank" class="text-decoration-none text-muted fs-sm">
                                                    Forgot your password?
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- / Setup account -->

                    </div>

                    <!-- Go to speciality stage -->
                    <div class="modal-footer" v-if="localContext && form.speciality && stage == 1">
                        <button type="button" class="btn btn-secondary btn-sm" @click.prevent="previousStage">Back</button>
                        <button :disabled="!canSave || isSaving" @click.prevent="nextStage" type="button"
                            class="btn btn-primary btn-sm">
                            <spinner v-if="isSaving" class="spinner-border-sm me-2"></spinner>
                            Next
                        </button>
                    </div>
                    <!-- / Go to speciality stage -->

                    <!-- Setup account stage -->
                    <div class="modal-footer" v-if="localContext && form.speciality && stage == 2">
                        <button type="button" class="btn btn-secondary btn-sm" @click.prevent="previousStage">Back</button>
                        
                        <!-- New Account Tab Button -->
                        <button v-if="activeTab === 'new-account'" :disabled="!canSaveNewAccount || isSaving" 
                                @click.prevent="attemptCreateAccountAndStartConversation" type="button" 
                                class="btn btn-primary btn-sm">
                            <spinner v-if="isSaving" class="spinner-border-sm me-2"></spinner>
                            {{ isSaving ? 'Creating Account...' : 'Create Account & Start Conversation' }}
                        </button>
                        
                        <!-- Login Tab Button -->
                        <button v-if="activeTab === 'login'" :disabled="!canSaveLogin || isSaving" 
                                @click.prevent="attemptLoginAndStartConversation" type="button" 
                                class="btn btn-primary btn-sm">
                            <spinner v-if="isSaving" class="spinner-border-sm me-2"></spinner>
                            {{ isSaving ? 'Logging In...' : 'Login & Start Conversation' }}
                        </button>
                    </div>
                    <!-- / Setup account stage -->

                </div>
            </div>
        </vue-final-modal>
        <!-- / Modal -->
    </div>

    <!-- Loading Overlay -->
    <div v-if="showLoadingOverlay" class="loading-overlay">
        <div class="loading-content">
            <spinner class="mb-3"></spinner>
            <h5>{{ loadingMessage }}</h5>
            <p class="text-muted">Please wait while we prepare everything for you.</p>
        </div>
    </div>
    <!-- / Loading Overlay -->
</template>

<script>
import _ from 'lodash';
import Display from '../../mixins/Display';
import RequiresContext from '../../mixins/RequiresContext';
import Spinner from '../Spinner.vue';
import { useToast } from 'vue-toastification';
const toast = useToast();
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import Forms from '../../mixins/Forms';

export default {
    props: ['panelConfiguration', 'referralPageId', 'advisorCompanyId', 'secondary'],
    components: { Spinner },
    mixins: [Display, RequiresContext, Forms],
    data() {
        return {
            showModal: false,

            stage: 0,
            activeTab: 'new-account',

            form: {
                speciality: null,
                description: '',
            },

            createAccountForm: {
                name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                company_name: '',
                agree_to_terms: true,
                marketing_consent: false
            },

            loginForm: {
                email: '',
                password: ''
            },

            isSaving: false,
            serverErrors: [],
            showLoadingOverlay: false,
            currentJobId: null
        }
    },
    computed: {
        ...mapGetters('whitelabelConfiguration', {
            whitelabelConfigurationId: 'whitelabelConfigurationId'
        }),

        canSave() {
            return this.form.speciality && this.form.description;
        },

        canSaveNewAccount() {
            return this.form.speciality && this.form.description && 
                   this.createAccountForm.name && this.createAccountForm.email && 
                   this.createAccountForm.phone && this.createAccountForm.password;
        },

        canSaveLogin() {
            return this.form.speciality && this.form.description && 
                   this.loginForm.email && this.loginForm.password;
        },

        // specialities() {
        //     let all = this.localContext ? this.localContext.specialities : [];
        //     let professionIds = _.map(this.panelConfiguration.professions, 'id');
        //     return _.filter(all, s => professionIds.includes(s.profession_id));
        // }

        specialityIdsFromUserRoles() {
            let specialityIds = [];
            // panelConfiguration.user_roles.*.specialities.*.id
            _.forEach(this.panelConfiguration.user_roles, ur => {
                _.forEach(ur.specialities, s => {
                    specialityIds.push(s.id);
                });
            });
            // Return unique speciality ids
            return _.uniq(specialityIds);
        },

        specialities() {
            let all = this.localContext ? this.localContext.specialities : [];
            let professionIds = _.map(this.panelConfiguration.professions, 'id');
            let specialitiesForProfessions = _.filter(all, s => professionIds.includes(s.profession_id));
            return _.filter(specialitiesForProfessions, s => this.specialityIdsFromUserRoles.includes(s.id));
        },

        loadingMessage() {
            // If we're in the saving process (registration/login), show appropriate message
            if (this.isSaving && this.showLoadingOverlay) {
                if (this.activeTab === 'new-account') {
                    return 'Creating your account...';
                } else {
                    return 'Logging you in...';
                }
            }
            
            const jobsLoaded = !this.$store.getters['jobs/isLoading'];
            const userRoleAvailable = this.$store.getters['auth/userRole'] !== null;
            const websocketListenerSetUp = this.$store.getters['websocketListener/listeningToUserRoleId'] !== null;
            
            // Check if the new job is in the jobs list (if we have a jobId to check)
            const jobs = this.$store.getters['jobs/jobs'];
            const newJobExists = jobs.some(job => job.id == this.currentJobId);
            
            if (!jobsLoaded) {
                return 'Loading your jobs...';
            } else if (!userRoleAvailable) {
                return 'Setting up your account...';
            } else if (!websocketListenerSetUp) {
                return 'Connecting to real-time updates...';
            } else if (jobsLoaded && !newJobExists && this.currentJobId) {
                return 'Refreshing job list...';
            } else {
                return 'Setting up your conversation...';
            }
        }
    },
    methods: {
        ...mapActions('auth', {
            handleUserRegistered: 'handleUserRegistered',
            attemptLoginInline: 'attemptLoginInline',
            loadAndSelectFirstClientUserRoleInline: 'loadAndSelectFirstClientUserRoleInline'
        }),

        reset() {
            this.form = {
                speciality: null,
                description: '',
            };
            this.createAccountForm = {
                name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                company_name: '',
                agree_to_terms: true,
                marketing_consent: false
            };
            this.loginForm = {
                email: '',
                password: ''
            };
            this.activeTab = 'new-account';
            this.currentJobId = null;
        },

        clearSpeciality() {
            this.form.speciality = null;
            this.stage = 0;
        },

        selectSpeciality(speciality) {
            this.form.speciality = speciality;
            this.stage = 1;
        },

        determineSearchParams() {
            return {
                speciality_id: this.form.speciality ? this.form.speciality.id : null,
                description: this.form.description,
                company_id: this.panelConfiguration.company_id,
                whitelabel_configuration_id: this.whitelabelConfigurationId,
                referral_page_id: this.referralPageId,
                advisor_company_id: this.advisorCompanyId
            };
        },

        openModal() {
            this.showModal = true;
        },

        switchTab(tabName) {
            this.activeTab = tabName;
        },

        nextStage() {
            if (this.stage == 0) {
                this.stage++;
            }
            if (this.stage == 1) {
                if (this.canSave) {
                    this.stage++;
                }
            }
            if (this.stage > 1) {
                return false;
            }
        },

        previousStage() {
            if (this.stage > 0) {
                this.stage--;
            }
        },

        attemptCreateAccountAndStartConversation() {
            let vm = this;
            vm.isSaving = true;
            vm.showLoadingOverlay = true; // Show loading overlay immediately
            
            axios.post(window.API_BASE + '/client-register', {
                name: vm.createAccountForm.name,
                email: vm.createAccountForm.email,
                password: vm.createAccountForm.password,
                // password_confirmation: vm.form.password_confirmation,
                password_confirmation: vm.createAccountForm.password,
                phone: vm.createAccountForm.phone,
                company_name: vm.createAccountForm.company_name,
                wcid: vm.whitelabelConfigurationId,
                referral_page_id: vm.referralPageId,
                advisor_company_id: vm.advisorCompanyId,
                agree_to_terms: vm.createAccountForm.agree_to_terms,
                marketing_consent: vm.createAccountForm.marketing_consent
            }).then(r => {
                vm.handleUserRegistered(r.data).then(r => {
                    vm.isSaving = false;
                    vm.startConversation();
                    // vm.$emit('registered');
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.showLoadingOverlay = false; // Hide overlay on error
                    vm.setAndNotifyErrors(e);
                });
            }).catch(e => {
                console.log(e);
                vm.isSaving = false;
                vm.showLoadingOverlay = false; // Hide overlay on error
                vm.setAndNotifyErrors(e);
            });
        },

        attemptLoginAndStartConversation() {
            let vm = this;
            vm.isSaving = true;
            vm.serverErrors = [];
            vm.showLoadingOverlay = true; // Show loading overlay immediately

            vm.attemptLoginInline({
                email: vm.loginForm.email,
                password: vm.loginForm.password
            }).then(() => {
                vm.loadAndSelectFirstClientUserRoleInline().then(rr => {
                    // vm.isSaving = false;
                    vm.startConversation();
                }).catch(ee => {
                    console.log(ee);
                    vm.isSaving = false;
                    vm.showLoadingOverlay = false; // Hide overlay on error
                    vm.setAndNotifyErrors(ee);
                })
            
            }).catch(e => {
                console.log(e);
                vm.isSaving = false;
                vm.showLoadingOverlay = false; // Hide overlay on error
                vm.setAndNotifyErrors(e);
            });
        },

        startConversation() {
            this.isSaving = true;
            this.serverErrors = [];

            axios.post(window.API_BASE + '/jobs/start-conversation-with-panel-provider', this.determineSearchParams())
                .then(r => {
                    this.isSaving = false;
                    this.showModal = false;
                    this.reset();
                    
                    // Wait for jobs to load and websockets to connect before redirecting
                    this.waitForJobsAndWebsockets(r.data.id);
                })
                .catch(error => {
                    this.isSaving = false;
                    let errors;
                    if (typeof error.response.data === 'object') {
                        errors = _.flatten(_.toArray(error.response.data.errors));
                    } else {
                        errors = ['Something went wrong. Please try again.'];
                    }
                    this.serverErrors = errors;
                    toast.error('There was an error starting your conversation. Please try again.');
                });
        },

        waitForJobsAndWebsockets(jobId) {
            // Show loading overlay
            this.showLoadingOverlay = true;
            this.currentJobId = jobId;
            
            // Force reload jobs to ensure the new job is included
            this.$store.dispatch('jobs/loadJobs');
            
            let checkInterval = setInterval(() => {
                // Check if jobs are loaded
                const jobsLoaded = !this.$store.getters['jobs/isLoading'];
                
                // Check if user role is available
                const userRoleAvailable = this.$store.getters['auth/userRole'] !== null;
                
                // Check if websockets are connected - handle different connection states
                let websocketsConnected = false;
                if (window.Echo && window.Echo.connector && window.Echo.connector.pusher) {
                    const connectionState = window.Echo.connector.pusher.connection.state;
                    websocketsConnected = connectionState === 'connected' || connectionState === 'connecting';
                }
                
                // Check if websocket listener is set up
                const websocketListenerSetUp = this.$store.getters['websocketListener/listeningToUserRoleId'] !== null;
                
                // Check if the new job is in the jobs list
                const jobs = this.$store.getters['jobs/jobs'];
                const newJobExists = jobs.some(job => job.id == jobId);
                
                if (jobsLoaded && websocketsConnected && userRoleAvailable && websocketListenerSetUp && newJobExists) {
                    clearInterval(checkInterval);
                    this.showLoadingOverlay = false;
                    this.currentJobId = null;
                    
                    // Navigate immediately since we confirmed the job exists
                    this.$router.push('/jobs/' + jobId);
                } else if (jobsLoaded && !newJobExists) {
                    // If jobs are loaded but the new job isn't there, reload jobs again
                    this.$store.dispatch('jobs/loadJobs');
                }
            }, 200);
            
            // Timeout after 10 seconds to prevent infinite waiting
            setTimeout(() => {
                clearInterval(checkInterval);
                this.showLoadingOverlay = false;
                this.currentJobId = null;
                this.$router.push('/jobs/' + jobId);
            }, 10000);
        }
    }
}
</script>

<style scoped lang="scss">
.panel-pricing-wrapper {
    width: 100%;
}

.btn-outline-primary {
    color: rgb(var(--primary-colour)) !important;
    border-color: rgb(var(--primary-colour)) !important;
}

.btn-outline-primary:hover {
    background-color: rgb(var(--primary-colour)) !important;
    color: white !important;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-content {
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    max-width: 400px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>